import { useAuth } from "../lib/auth";
import { signupPath } from "../lib/nextParam";
import { ButtonLink, Card, PageHeader } from "../components/ui";

const STEPS: { title: string; body: string }[] = [
  {
    title: "Tell us the basics",
    body: "Name, dates, and where it is.",
  },
  {
    title: "Pick the age groups",
    body: "Each one becomes a division, with its own pools, standings, and a championship bracket.",
  },
  {
    title: "You run it",
    body: "Registration, pools, the schedule, scores, seeding, and the bracket.",
  },
];

export function Host() {
  const { idToken } = useAuth();

  return (
    <div className="mx-auto max-w-md space-y-8">
      <PageHeader
        eyebrow="Hosting"
        title="Host your tournament"
        subtitle="Create the event, then run it yourself. Free."
      />
      <Card className="p-5 sm:p-6">
        <ol className="space-y-4">
          {STEPS.map((step, i) => (
            <li key={step.title} className="flex gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-50 text-sm font-semibold text-brandText">
                {i + 1}
              </span>
              <div className="min-w-0">
                <div className="font-medium text-navy-950">{step.title}</div>
                <p className="max-w-prose text-sm text-slate-600">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
        <ButtonLink
          to={idToken ? "/host/new" : signupPath("/host/new")}
          size="lg"
          className="mt-6 w-full"
        >
          Create a tournament
        </ButtonLink>
      </Card>
    </div>
  );
}
